module.exports = __webpack_public_path__ + "index_pc/img/login-img.7d2db76c.png";